import React, { useEffect, useState } from "react";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "../Main";
import MobileForm from "./MobileForm";
import MobilePlans from "./MobilePlans";
import { detectOperatorByNumber, doRechargeOperatorByNumber, getRecharges_Plans, rechargeOperatorByNumber } from "../../api/rechages.Api";
import { useWallet } from "../../context/walletContext";
import { Autocomplete, FormControl, FormLabel, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNotify } from "../../context/NotifyContext";
import { AppBreadcrumbs } from "../../components/listing";
const MobileRecharge = () => {
  const [mobNumber, setMobNumber] = useState("");
  const {refreshWalletCart} = useWallet()
  
const {notify} = useNotify()
const {slug} = useParams()

  const [operatorName, setOperatorName] = useState(null);
  const [operatorCircle, setOperatorCircle] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showPlans, setShowPlans] = useState(false);
  const [showAmountForm, setShowAmountForm] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
const [rechargePlansData, setRechargePlansData] = useState([]);
const [operators,setOperators] = useState([])
  const [selectedOperatorId, setSelectedOperatorId] = useState("");
  const [selectedOperator, setSelectedOperator] = useState(null);

const slugCategoryMap = {
  recharge: "Prepaid",
  dth: "DTH",
  postpaid: "Postpaid",
  broadband: "Broadband",
  electricity: "Electricity",
};
const categoryFilter = slugCategoryMap[slug] || "Prepaid";


const handleSubmit = async (e) => {
  e.preventDefault();
  if (!mobNumber.trim()) {
    notify("Enter mobile number",'error');
    return;
  }
  try {
    const payload = { mobile: mobNumber, op: operatorName, circle: operatorCircle };
    const res = await getRecharges_Plans(payload);
    if (res?.data?.plans) {
      notify("Recharge plans fetched!",'success');
      const rawData = res.data.plans;
setRechargePlansData(rawData)
      setShowPlans(true)
      setShowAmountForm(true)
    } else {
      notify(res?.message  ,"error");
    }
  } catch (err) {
 
  }
};
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (mobNumber?.length !== 10) return;
    const delay = setTimeout(() => {
      handleDetectOperator(mobNumber);
    }, 2000); // 2 seconds debounce
    return () => clearTimeout(delay); // user type kare to previous timer clear
  }, [mobNumber]);


    useEffect(() => {
      const load = async () => {
        const res = await rechargeOperatorByNumber();
        if (res?.success) {
          console.log("get the info",res?.data)
          setOperators(res.data?.info || []);
        }
      };
      load();
    }, []);


const handleDetectOperator = async (number) => {
  if (!number || number.length !== 10) return;

  const res = await detectOperatorByNumber({ mobile: number });

  if (res.success) {

    console.log("get the response",res?.data)
const info_get = res.data?.info || {}
    setOperatorName(info_get?.operator);
    setOperatorCircle(info_get?.circle);
  } else {
    notify(res.message, "error");
  }
};

const doRechargePlans = async () => {


  if (!mobNumber || !selectedOperatorId || !operatorCircle || !selectedAmount) {
    return notify("All fields are required", "error");
  }

const payload = {
  mobile: mobNumber,
  operator: selectedOperatorId,   // ✅ ID send karo
  circle: operatorCircle,
  amount: selectedAmount,
  category: slug,
};

  const res = await doRechargeOperatorByNumber(payload);

  if (res?.success) {
    notify(res.message || "Recharge successful", "success");

    setMobNumber("");
    setShowPlans(false);
    setShowPopup(false);
    setShowAmountForm(false);
    setOperatorName(null);
    setOperatorCircle(null);
    refreshWalletCart();
  } else {
    // 🔥 Wallet mismatch / partner error
    notify(
      res?.message || "Recharge failed",
      "error"
    );
  }
};


const flattenPlans = (plansObj) => {
  if (!plansObj) return [];

  return Object.values(plansObj)
    .filter(Array.isArray) // sirf arrays lo
    .flat();               // sabko ek array bana do
};


useEffect(() => {
  if (!selectedAmount || !rechargePlansData) return;

  const timer = setTimeout(() => {
    const allPlans = flattenPlans(rechargePlansData);

    const matchedPlan = allPlans.find(
      (plan) => String(plan.rs) === String(selectedAmount)
    );

    if (matchedPlan) {
      setSelectedDescription(matchedPlan.desc || "");
      setShowPlans(true); // plans panel open
    } else {
      setSelectedDescription("");
    }
  }, 2000); // ⏱️ 2 seconds wait

  return () => clearTimeout(timer);
}, [selectedAmount, rechargePlansData]);


  return (
    <Main showRightPanel={false}>
  <div className="">
    <AppBreadcrumbs
      items={[
        { label: "Dashboard", to: "/" },
        { label: "Recharge & Bills - 1" },
        { label: "Prepaid Mobile Recharge" },
      ]}
    />
   </div>
  <div className="flex flex-col lg:flex-row gap-4 w-full mt-4">
    <div className="flex flex-col gap-4 w-full lg:w-[280px]">
      <div className="ds-card p-3 sm:p-4 w-full">
        <h2 className="text-[13px] sm:text-sm font-semibold mb-3 whitespace-nowrap text-[var(--text-dark)]">
          Prepaid Mobile Recharge
        </h2>

   <div className="mt-3 mb-2">
       <label className="text-sm font-medium text-[var(--text-muted)]">Select Operator</label>

 <Autocomplete
  options={operators.filter(op => op.category === categoryFilter)}
  getOptionLabel={(op) => op.name || ""}
  value={selectedOperator}
  onChange={(e, val) => {
    setSelectedOperator(val);
    setSelectedOperatorId(val?.id || ""); 

  }}
  renderInput={(params) => (
    <TextField {...params} size="small" placeholder="Search Operator" />
  )}
/>
   </div>



   <FormControl fullWidth className="mb-4" required>
<FormLabel required sx={{
  color: "text.secondary",
  "& .MuiFormLabel-asterisk": { color: "var(--error-color)" }
}}>
 Mobile Number
</FormLabel>
</FormControl>

     <input
  type="tel"
  inputMode="numeric"
  pattern="[0-9]*"
  disabled={showPlans}
  value={mobNumber}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobNumber(value);
    }
  }}
  placeholder="Enter Phone Number"
  className="ds-input text-[12px] sm:text-sm"
/>
      </div>
      {operatorName && operatorName && (
        <div className="ds-card p-3 sm:p-4 w-full">
          <h2 className="text-[13px] sm:text-sm font-semibold text-[var(--text-dark)] mb-4">
            Number Details
          </h2>
          <div className="space-y-3">
            <div>
              <label className="text-[var(--text-muted)] text-[12px] sm:text-sm">
                Operator <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={operatorName}
                className="ds-input bg-[var(--bg-app)] text-[12px] sm:text-sm"
                readOnly
              />
            </div>
            <div>
              <label className="text-[var(--text-muted)] text-[12px] sm:text-sm">
                Circle <span className="text-[var(--error-color)]">*</span>
              </label>
              <input
                type="text"
                value={operatorCircle}
                className="ds-input bg-[var(--bg-app)] text-[12px] sm:text-sm"
                readOnly/>
            </div>
            <div className="flex items-center justify-between gap-2">
              <button
                type="button"
                className="ds-btn ds-btn-ghost text-[11px] sm:text-xs py-1 px-2"
                onClick={() => setShowPopup(true)}>
                Change Details
              </button>
              <button
              type="button"
              disabled={!operatorCircle || !operatorName}
                className="ds-btn ds-btn-primary text-[11px] sm:text-xs py-1 px-2"
                      onClick={handleSubmit}
              >
                Browse Plan
              </button>
            </div>
          </div>
        </div>
      )}
      {showAmountForm && (
        <div className="ds-card p-3 sm:p-4 w-full">
          <h2 className="text-[13px] sm:text-sm font-semibold text-[var(--text-dark)] mb-3">
            Mobile Recharge Details
          </h2>
          <label className="text-[var(--text-muted)] text-[12px] sm:text-sm">Recharge Amount <span className="text-[var(--error-color)] pr-1"> *</span></label>
          <input
            type="text"
            value={selectedAmount}
            onChange={(e) => setSelectedAmount(e.target.value)}
            placeholder="Enter Amount"
            className="ds-input text-[12px] sm:text-sm mb-2"
          />
          {selectedDescription && (
            <p className="text-[11px] sm:text-sm text-[var(--text-muted)] mb-3">{selectedDescription}</p>
          )}
                         <button
                    type="submit"
           disabled={!showAmountForm || loading}
onClick={doRechargePlans} className="ds-btn ds-btn-primary ds-btn-block">
                       {loading ? "Processing..." : "Recharge Now"}
                  </button>
        </div>
      )}
    </div>
    {showPlans && (
      <div className="flex-1">
        {}
             <MobilePlans
    plansData ={rechargePlansData}
          onClose={() => setShowPlans(false)}
          onSelectPlan={(amount, description) => {
            setSelectedAmount(amount);
            setSelectedDescription(description);
          }}
        />
      </div>
    )}
  </div>
  <MobileForm
    isOpen={showPopup}
    onClose={() => setShowPopup(false)}
    circlename={operatorCircle}
    operatorname={operatorName}
    onSubmit={(data) => {
      setOperatorName(data.operator);
      setOperatorCircle(data.circle);
      toast.success("Details updated successfully!", {
        position: "top-center",
        autoClose: 2000,
      });
      setShowPopup(false);
    }}
  />
</Main>
  );
};
export default MobileRecharge;
